import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../../hooks/use-http";
import convertToExcel from "../../../../../components/ExportToExcel";
import Pagination from "../../../../../components/Pagination";
import { AutoComplete } from "antd";
import { toast } from "react-toastify";
import { formatNumber } from "../../../../../components/formatNumber";

const FarmerSummaryReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [seasonlist, setSeasonlist] = useState(null);
  const [seasonId, setSeasonId] = useState();
  const [ranchId, setRanchId] = useState();
  const [ranchData, setRanchData] = useState([]);
  const [fieldName, setFieldName] = useState("");
  const [cropId, setCropId] = useState("");
  const [cropData, setCropData] = useState([]);
  const [fieldOptions, setFieldOptions] = useState([]);
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [data, setData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = Array.isArray(data)
    ? data.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);


  const { sendRequest: getSeason } = useHttp();
  useEffect(() => {
    getSeason(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setSeasonlist(data);
      }
    );
  }, [getSeason]);

  const { sendRequest: getCropData } = useHttp();

  useEffect(() => {
    getCropData(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setCropData(data.output || []);
      }
    );
  }, [getCropData]);

  const { sendRequest: getRanch } = useHttp();
  useEffect(() => {
    getRanch(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setRanchData(data);
      }
    );
  }, [getRanch]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }


    getFarmerNumber(
      {
        url: `/api/agronomyFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);


  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  const { sendRequest: getBudgetData } = useHttp();

  const fillBudgetData = (e) => {
    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (seasonId > 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }

    if (ranchId > 0) {
      urlfilter = urlfilter + `&ranchId=${ranchId}`;
    }
    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }
    if (farmerNumber) {
      urlfilter = urlfilter + `&farmerNo=${farmerNumber}`;
    }
    if (cropId && cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }

    var url = `/api/farmerSummaryReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getBudgetData(
      {
        url: url,
      },
      (data) => {
        console.log(data.farmerData);

        setData(data.farmerData);
      }
    );
  };

  useEffect(() => {
    fillBudgetData();
  }, [seasonId, employeeId, ranchId, fieldName, cropId]);


  useEffect(() => {
    if (!ranchId) {
      setFieldOptions([]);
      return;
    }

    var urlfilter = `&ranchId=${ranchId}`;

    getBudgetData(
      {
        url: `/api/farmerSummaryReport/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}${urlfilter}`,
      },
      (res) => {
        const reportData = res?.farmerData || [];

        const uniqueFields = [
          ...new Set(
            reportData
              .map((item) => item.fieldCode)
              .filter(Boolean)
          ),
        ];

        const fieldList = uniqueFields.map((f) => ({
          fieldCode: f,
        }));

        setFieldOptions(fieldList);
      }
    );
  }, [ranchId]);

  // const handleExportExcel = () => {
  //   const filename = "FarmerSummaryReport.xlsx";

  //   const headers = [
  //     "Farmer ID",
  //     "Farmer Name",
  //     "Crop",
  //     // "Field Category",
  //     "Field",
  //     "Region Name",
  //     "Ranch Name",
  //     "Field Code",
  //     "Plot Name",
  //     "Budget Template Name",
  //     "Season Name",
  //     "Extension Officer",
  //     "Field Size",
  //     "Field Size Unit",
  //   ];

  //   const actualInputHeaders = inputTypes.length
  //     ? inputTypes.map((type) => `Actual Input - ${type}`)
  //     : ["Actual Input -"];
  //   const planInputHeaders = planInputTypes.length
  //     ? planInputTypes.map((type) => `Plan Input - ${type}`)
  //     : ["Plan Input -"];
  //   const otherHeaders = otherTypes.length
  //     ? otherTypes.map((type) => `Other - ${type}`)
  //     : ["Other -"];

  //   const yieldHeaders = ["Yield Good", "Yield Bad"];

  //   const finalHeaders = [
  //     ...headers,
  //     ...actualInputHeaders,
  //     ...planInputHeaders,
  //     ...otherHeaders,
  //     ...yieldHeaders,
  //     "Total Cost",
  //     "Harvest Cost",
  //     "Profit / Loss",
  //   ];

  //   const rows = data.map((itm) => {
  //     const row = {
  //       "Farmer ID": itm.farmerNo ?? "-",
  //       "Farmer Name": itm.farmerName ?? "-",
  //       Crop: itm.cropName ?? "-",
  //       // "Field Category": itm.ranchName ?? "-",
  //       "Field ": itm.ranchName ?? "-",
  //       "RegionName ": itm.regionName ?? "-",
  //       "Ranch Name ": itm.ranchName ?? "-",
  //       "Field Code ": itm.fieldCode ?? "-",
  //       "Plot Name ": itm.plotName ?? "-",
  //       "Budget Template Name": itm.farmerBudgetTemplateName ?? "-",
  //       "Season Name": itm.seasonName ?? "-",
  //       "Extension Officer": itm.executiveName ?? "-",
  //       "Field Size": itm.plotArea ?? "-",
  //       "Field Size Unit": itm.plotAreaUnit ?? "-",
  //     };

  //     const actualInputs = Array.isArray(itm.actualInputs)
  //       ? itm.actualInputs
  //       : [];
  //     const planInputs = Array.isArray(itm.planInputs) ? itm.planInputs : [];
  //     const others = Array.isArray(itm.other) ? itm.other : [];

  //     if (inputTypes.length > 0) {
  //       inputTypes.forEach((type) => {
  //         const item = actualInputs.find((x) => x.poductType === type);
  //         row[`Actual Input - ${type}`] = item?.totalproductAmount ?? "-";
  //       });
  //     } else {
  //       row["Actual Input -"] = "-";
  //     }

  //     if (planInputTypes.length > 0) {
  //       planInputTypes.forEach((type) => {
  //         const item = planInputs.find((x) => x.poductType === type);
  //         row[`Plan Input - ${type}`] = item?.totalproductAmount ?? "-";
  //       });
  //     } else {
  //       row["Plan Input -"] = "-";
  //     }

  //     if (otherTypes.length > 0) {
  //       otherTypes.forEach((type) => {
  //         const item = others.find((x) => x.poductType === type);
  //         row[`Other - ${type}`] = item?.totalproductAmount ?? "-";
  //       });
  //     } else {
  //       row["Other -"] = "-";
  //     }

  //     row["Yield Good"] = itm.vehicleQualitySummary?.good?.totalCombined ?? "-";
  //     row["Yield Bad"] = itm.vehicleQualitySummary?.bad?.totalCombined ?? "-";

  //     row["Total Cost"] = itm.totalcost ?? "-";
  //     row["Harvest Cost"] = itm.harvestCost ?? "-";
  //     row["Profit / Loss"] = itm.profitLoss ?? "-";

  //     return row;
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(rows);
  //   XLSX.utils.sheet_add_aoa(worksheet, [finalHeaders], { origin: "A1" });

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Farmer Summary Report");

  //   XLSX.writeFile(workbook, filename);
  // };

  const fieldsToExport = [
    "farmerNo",
    "farmerName",
    "gender",
    "ranchName",
    "fieldCode",
    "plotArea",
    "cropName",
    "inputCostActual",
    "inputCostMarkup",
    "labourCostActual",
    "labourCostMarkup",
    "harvest",
    "programmatic",
    "totalCost",
    "loanRepayment",
    "farmerActualPayment",
    "farmerTotalHarvest",
  ];

  const customHeaders = [
    "Farmer No",
    "Farmer Name",
    "Gender",
    "Ranch Name",
    "Field Name",
    "Plot Area",
    "Crop",
    "Cost of Inputs - Actual",
    "Cost of Inputs - Markup",
    "Cost of Machine Labor - Actual",
    "Cost of Machine Labor - Markup",
    "Harvest",
    "Programmatic",
    "Total Cost",
    "Loan Repayment",
    "Farmers actual payment",
    "Farmers Total harvest",
  ];

  const handleExportExcel = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }
    const filename = "Farmer Summary Report.xlsx";
    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title">Farmer Summary</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Crop Name</label>

                  <select
                    className="form-control"
                    value={cropId}
                    onChange={(e) => {
                      setCropId(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {cropData &&
                      cropData.map((x) => (
                        <option key={x.CropId} value={x.CropId}>
                          {x.CropName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season</label>
                  <select
                    id="season"
                    className="form-control"
                    value={seasonId}
                    onChange={(e) => setSeasonId(e.target.value || 0)}
                    required
                  >
                    <option value="">Select</option>
                    {seasonlist &&
                      seasonlist.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch</label>
                  <select
                    id="ranch"
                    className="form-control"
                    value={ranchId}
                    onChange={(e) => {
                      setRanchId(e.target.value || 0);
                      setFieldName("");
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {ranchData &&
                      ranchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Field Name</label>
                  <select
                    className="form-control"
                    value={fieldName}
                    onChange={(e) => {
                      setFieldName(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {fieldOptions.map((x, i) => (
                      <option key={i} value={x.fieldCode}>
                        {x.fieldCode}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Field Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value || 0);
                      setFarmerNumber("");
                      setData([]);
                    }}
                  >
                    <option value={0}>Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillBudgetData();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Farmer No</th>
                          <th>Farmer Name</th>
                          <th>Executive Name</th>
                          <th>Gender</th>
                          <th>Ranch Name</th>
                          <th>Field Name</th>
                          <th>Plot Area</th>
                          <th>Crop</th>
                          <th>Season Name</th>
                          <th>Cost of Inputs - Actual</th>
                          <th>Cost of Inputs - Markup</th>
                          <th>Cost of Machine Labor - Actual</th>
                          <th>Cost of Machine Labor - Markup</th>
                          <th>Harvest</th>
                          <th>Programmatic</th>
                          <th>Total Cost</th>
                          <th>Farmers Total harvest</th>
                          <th>Loan Payment</th>
                          <th>Farmers actual payment</th>
                          <th>Loan Balance</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems.map((itm, i) => (
                          <tr key={i}>
                            <td>{itm.farmerNo}</td>
                            <td>{itm.farmerName}</td>
                            <td>{itm.executiveName}</td>
                            <td>{itm.gender}</td>
                            <td>{itm.ranchName}</td>
                            <td>{itm.fieldCode}</td>
                            <td>{formatNumber(itm.plotArea)}</td>
                            <td>{itm.cropName}</td>
                            <td>{itm.seasonName}</td>
                            <td>{formatNumber(itm.inputCostActual)}</td>
                            <td>{formatNumber(itm.inputCostMarkup)}</td>
                            <td>{formatNumber(itm.labourCostActual)}</td>
                            <td>{formatNumber(itm.labourCostMarkup)}</td>
                            <td>{formatNumber(itm.harvest)}</td>
                            <td>{formatNumber(itm.programmatic)}</td>
                            <td>{formatNumber(itm.totalCost)}</td>
                            <td>{formatNumber(itm.farmerTotalHarvest)}</td>
                            <td>{formatNumber(itm.loanPayment)}</td>
                            <td>{formatNumber(itm.farmerActualPayment)}</td>
                            <td>{formatNumber(itm.loanBalance)}</td>
                          </tr>
                        ))}
                      </tbody>

                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerSummaryReport;
